module.exports = __webpack_public_path__ + "img/lg-為什麼一定要吃甜點.0bd653f6.svg";